<template>
  <v-container class="container-card">
    <v-card>
      <Tabela />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Tabela from "../../components/parametros/bonusTipoMeta/TabelaBonusTipoMeta.vue";

export default {
  name: "BonusTipoMeta",

  components: {
    Tabela
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Tipo Meta Pagamento");
  }
};
</script>
